<template>
  <v-div class="AssociatedConference" border-inverted-bottom-thick mt-3 pb-3>
    <h2 class="mb-2 ml-2 font-weight-bold font-smaller">Conference</h2>
    <v-div pl-2 font-smaller>
      <nuxt-link v-if="isOriginPartner" :to="to">
        {{ article.event.title }}
        <span class="d-sr-only">[opens in a new tab]</span>
        <v-icon small color="primary" aria-hidden="true">{{
          mdiOpenInNew
        }}</v-icon>
      </nuxt-link>
      <a v-else :href="to">
        {{ article.event.title }}
        <span class="d-sr-only">[opens in a new tab]</span>
        <v-icon small color="primary" aria-hidden="true">{{
          mdiOpenInNew
        }}</v-icon>
      </a>
    </v-div>
  </v-div>
</template>

<script>
import { mdiOpenInNew } from "@mdi/js";
export default {
  name: "AssociatedConference",
  props: {
    article: { type: Object, required: true },
  },
  data() {
    return {
      mdiOpenInNew,
    };
  },
  computed: {
    partner() {
      return this.$config.partner;
    },
    isOriginPartner() {
      return this.article.origin?.toLowerCase() === this.partner.toLowerCase();
    },
    to() {
      return `/engage/${this.article.origin.toLowerCase()}/event-details/${
        this.article.event.id
      }`;
    },
  },
};
</script>
